/**
 * Éco-Score Form — collection matières (CollectionType Symfony) :
 *  - Bouton "+ Ajouter une matière" → clone le prototype
 *  - Bouton "Supprimer" → retire l'item
 *
 * Les selects dépendants Marque ↔ Gamme sont pris en charge par
 * `brand-range-selects`, commun à tous les formulaires du même motif.
 */
export default function initEcoscoreForm(): void {
    initMaterialsCollection();
}

function initMaterialsCollection(): void {
    const container = document.getElementById('ecoscore-materials');
    const addBtn    = document.getElementById('add-material');
    if (!container || !addBtn) return;

    let index = parseInt(container.dataset.index ?? '0', 10);

    // Attache les boutons Supprimer sur les items existants au chargement
    container.querySelectorAll<HTMLElement>('.remove-material').forEach(attachRemove);

    // Ajouter une matière
    addBtn.addEventListener('click', () => {
        const prototype = container.dataset.prototype;
        if (!prototype) return;

        const html    = prototype.replace(/__name__/g, String(index++));
        const wrapper = buildMaterialItem(html);
        attachRemove(wrapper.querySelector<HTMLElement>('.remove-material'));
        container.appendChild(wrapper);
    });
}

function buildMaterialItem(prototypeHtml: string): HTMLElement {
    // Parse le prototype complet pour en extraire les champs
    const tmp = document.createElement('div');
    tmp.innerHTML = prototypeHtml;

    const materialIdBlock = extractFieldBlock(tmp, 'materialId') ?? '';
    const shareBlock      = extractFieldBlock(tmp, 'share') ?? '';
    const countryBlock    = extractFieldBlock(tmp, 'country') ?? '';

    const wrapper = document.createElement('div');
    wrapper.classList.add('material-item', 'card', 'card-body', 'py-2', 'mb-2', 'text-bg-light');
    wrapper.innerHTML = `
        <div class="row g-2 align-items-end">
            <div class="col-sm-5">${materialIdBlock}</div>
            <div class="col-sm-2">${shareBlock}</div>
            <div class="col-sm-4">${countryBlock}</div>
            <div class="col-sm-1 text-end">
                <button type="button" class="btn btn-sm btn-outline-danger remove-material mb-3" title="Supprimer">
                    <span class="bi-trash"></span>
                </button>
            </div>
        </div>`;
    return wrapper;
}

/** Extrait le bloc .mb-3 contenant un champ dont l'id se termine par _<suffix> */
function extractFieldBlock(root: HTMLElement, suffix: string): string | null {
    const el = root.querySelector(`[id$="_${suffix}"]`);
    return el?.closest('.mb-3')?.outerHTML ?? el?.outerHTML ?? null;
}

function attachRemove(btn: HTMLElement | null): void {
    btn?.addEventListener('click', () => btn.closest('.material-item')?.remove());
}
